import { ButtonArea } from 'apps/wrapper/src/components/shared/button-area/button-area';
import { CloseButton, DialogSubTitle, DialogToolbar } from 'apps/wrapper/src/components/shared/dialog/dialog.styles';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import moment from 'moment';
import { FC, useState } from 'react';
import { CreatePayerSetupWizardLink } from '../../../shared/utils/iv-deep-link';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const RELATIONSHIPS_PAGE_ID = 101;

const ProviderRelationshipInvalidDialog: FC = () => {
  const { publish } = useEventBus();
  const { opened, onClose, isLoading, locationId, appointmentRequest, getProvider, ivSummary } =
    useApptRequestIvStatusDialog();
  const [provider] = useState(getProvider(ivSummary?.idProvider));

  const onUpdateProviderRelationClick = async () => {
    if (!ivSummary?.idCarrierName) {
      console.error('Carrier Name ID is missing');

      return;
    }

    publish({
      messageType: 'navigate',
      data: {
        ...CreatePayerSetupWizardLink(locationId, ivSummary?.idCarrierName, RELATIONSHIPS_PAGE_ID),
        crossFrame: true
      }
    });
    onClose();
  };

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateReceived && <>&nbsp;- Run {moment.utc(ivSummary.dateReceived).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        The provider relationship between {provider ? provider.name : 'Current Provider'}&nbsp; and {ivSummary?.idPayer}{' '}
        has returned as "invalid".
        <br />
        <br />
        Please confirm the relationship and correct the issue to rerun the verification process. Alternatively, you may
        manually verify the patient or designate them as self-pay.
      </DialogSubTitle>
      <br />
      <ButtonArea
        title="Fix Now"
        buttons={[{ title: 'Update Provider Relation', onClick: onUpdateProviderRelationClick }]}
      />
      <IvInfo />
      <br /> <br />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(ProviderRelationshipInvalidDialog);
